module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/ajax-loader-7b9776076d5fceef4993b55c9383dedd.gif";